@if ((alerts$ | async).length > 0) {
  <div>
    <rask-message-panel
      [numberOfItemsToDisplay]="5"
      [maxNumOfRows]="2"
      [items]="alerts$"
      (anchorClick)="handleMessagePanelClick($event)">
    </rask-message-panel>
  </div>
}